import cx from 'classnames'
import Icon from '../Icon/Icon'

import './Seat.scss'

const Seat = ({ type = 'classic', size = 'single', disabled, className, style, isSelected, onClick }) => {
    const seatClassName = cx(
        `seat seat-${size} seat__${isSelected ? 'selected' : type} d-flex justify-content-center align-items-center`,
        disabled && 'disabled',
        className
    )

    const seatIcon = ['wheelchair', 'positionable', 'vip'].includes(type) && !isSelected && (
        <Icon name={type} className="w-100 h-100 p-1" />
    )

    const reservedLine = type === 'reserved' && <span className={`line-${size}`} />

    return (
        <div data-testid="seat" onClick={onClick} className={seatClassName} style={style}>
            {seatIcon}
            {reservedLine}
        </div>
    )
}

export default Seat
